import { Placeholder, Text } from '@stitch-fix/mode-react';
import { ResultsPlaceholder } from '../ResultsLayout';

/**
 * The `PagePlaceholder` component renders loading placeholders for
 * UI elements rendered on the Search, Saved Items, and Bought pages. `PagePlaceholder`
 * should be rendered while waiting for the page to verify the client has access to these pages.
 */
export const PagePlaceholder = () => <>
    {/* Placeholder for title "Styles that go with..." */}
    <Text setting="title-medium" mb={0.5}>
      <Placeholder maxWidth={20} mx="auto" />
    </Text>
    {/* Placeholder for `ResultsLayout` */}
    <ResultsPlaceholder />
  </>;